<template>
  <ul class="main-product__sidebar-usp">
    <li
      v-for="(block, index) of blocks"
      :key="index"
      class="text-heading-s"
    >
      <div class="main-product__sidebar-icon " v-if="block.check == false && block.checkproduct == false && block.text" >
        <responsive-image
          v-if="block.icon.src"

          :image="{
            src: block.icon.src
          }"
          ratio="1:1"
        />
      </div>
      <div class="main-product__sidebar-icon variant_usp_img" v-if="block.check == true && variantUsp && block.checkproduct == false"  >
        <responsive-image
          v-if="block.icon.src && variantUsp"

          :image="{
            src: block.icon.src
          }"
          ratio="1:1"
       
        />
      </div>
      <div class="main-product__sidebar-icon " v-if="block.check == false && product.productUsp && block.checkproduct == true"  >
        <responsive-image
          v-if="block.icon.src && product.productUsp"

          :image="{
            src: block.icon.src
          }"
          ratio="1:1"
  
        />
      </div>
      <span  class="texting"  v-if="block.check == false"  v-text="block.text"></span> 
      <span class="varianttexting" v-if="block.check == true && block.checkproduct == false" v-text="variantUsp"  :style="{ color: block.color } " @click="handleclick"></span>
      <span class="texting" v-if="block.check == false && product.productUsp && block.checkproduct == true" v-text="product.productUsp"  :style="{ color: block.color } " @click="handleclick"></span>
    </li>
  </ul>
</template>

<!-- <script>
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'MainProductSidebarUsp',
  components: {
    ResponsiveImage,
  },
  props: {
    blocks: {
      type: [Array],
      default: () => {
        return []
      },
    },
  },
}
</script> -->
<script>
import ResponsiveImage from '~global/images/responsive-image'

export default {
  name: 'MainProductSidebarUsp',
  components: {
    ResponsiveImage,
  },
  props: {
    blocks: {
      type: Array,
      default: () => []
    },
    product: {
      type: [Boolean, Object],
      default: false
    },
    variant: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      variantUsp: this.product.variants[0].shipsIn,
      shipsInval: false,
    }
  },
  mounted() {
    this.getVariantUsp();
    if(this.variantUsp ==  null || this.variantUsp == ''){
      if(document.getElementsByClassName('variant_usp_img').length > 0){
        document.getElementsByClassName('variant_usp_img')[0].style.display = 'none'
      }
    }
  },
  methods: {
    handleclick() {
      this.$emit('variant-usp', this.variant);
    },
    getVariantUsp() {
      const id = new URLSearchParams(window.location.search).get('variant');
     
      if (!id || !this.product || !this.product.variants) {
        return;
      }

      let shippingAvailable = false;
      let shipsIn = "";

      for (let val of this.product.variants) {
     
        if ( val['id'] == id) {
          
        
            shipsIn = val['shipsIn'];
            shippingAvailable = true;
          
          break;
        }
      }
      this.variantUsp = shipsIn;
      this.shipsInval = shippingAvailable;
   
    }
  }
}
</script>
